const KEY = "mmp_pending_analysis";

export const getPending = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
};

export const setPending = (id, token) => localStorage.setItem(KEY, JSON.stringify({ id, token }));
export const clearPending = () => localStorage.removeItem(KEY);

export const postAuthPath = () => (getPending() ? "/ma-carte?claim=1" : "/dashboard");
